export const getInputType = (fieldId: string, showPassword: boolean) => {
  if (fieldId === 'email') return 'text'; // Always text for email field
  if (fieldId === 'password') return showPassword ? 'text' : 'password'; // Toggle visibility for password field
  return 'text'; // Default to text input for other fields
};
